import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-188d833a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Mount ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Selected Hound from Marketplace")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__armor" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hound-card__img__neon" }, null, -1))
const _hoisted_6 = { class: "hound-card__info" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" You own this hound. This will be treated as internal breeding (you won't need to pay the breeding fee). ")
const _hoisted_8 = { style: {"margin-right":"2rem"} }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Breeding Fee:")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "USD", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("BREED")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_text = _resolveComponent("n-text")!
  const _component_n_h4 = _resolveComponent("n-h4")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_form = _resolveComponent("n-form")!

  return (_openBlock(), _createBlock(_component_n_form, {
    model: _ctx.formValue,
    ref: "formRef",
    onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.breed()), ["prevent"])),
    rules: _ctx.rules
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_card, {
        segmented: {
        footer: 'soft',
        content: true
      },
        role: "modal",
        closable: "",
        onClose: _ctx.cancel
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_n_space, { vertical: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_n_alert, { type: "info" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.platformFee) + " " + _toDisplayString(_ctx.currencyName) + " platform fee and " + _toDisplayString(_ctx.transactionCost) + " " + _toDisplayString(_ctx.transactionCurrencyName) + " transaction costs will be included in the total amount. ", 1)
                ]),
                _: 1
              }),
              (_ctx.hound && _ctx.eth.userAddress === _ctx.hound.owner)
                ? (_openBlock(), _createBlock(_component_n_alert, {
                    key: 0,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        action: _withCtx(() => [
          _createVNode(_component_n_space, {
            align: "center",
            justify: "space-between"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_n_space, {
                    align: "center",
                    size: _ctx.exchangeRatesAvailable && _ctx.exchangeRates[_ctx.currencyId] ? 'medium' : [4, 4]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_text, null, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_n_space, {
                        vertical: "",
                        size: [1, 1]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_n_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatNumberDecimals(_ctx.eth.utils.formatEther(_ctx.breedingFee))) + " ", 1),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.currencyName), 1)
                            ]),
                            _: 1
                          }),
                          (_ctx.exchangeRatesAvailable && _ctx.exchangeRates[_ctx.currencyId])
                            ? (_openBlock(), _createBlock(_component_n_text, {
                                key: 0,
                                depth: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.convertToUSD(_ctx.formatNumberDecimals(_ctx.eth.utils.formatEther(_ctx.breedingFee)), false, _ctx.currencyId)) + " ", 1),
                                  _hoisted_10
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["size"])
                ])
              ]),
              _createVNode(_component_n_space, { justify: "right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_button, {
                    disabled: _ctx.loading,
                    type: "primary",
                    "attr-type": "submit",
                    loading: _ctx.loading
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_n_text, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          (_ctx.hound)
            ? (_openBlock(), _createBlock(_component_n_card, {
                key: 0,
                style: {"margin-top":"1rem"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["hound-card avatar", `
            avatar-component-${_ctx.hound.extensionTraits ? _ctx.hound.extensionTraits : _ctx.hound.head[3]}-${_ctx.hound.color[3]}
            avatar-neon-${_ctx.hound.extensionTraits ? _ctx.hound.extensionTraits : _ctx.hound.head[3]}-${_ctx.hound.color[2]}
          `])
                  }, [
                    _createElementVNode("div", null, [
                      _hoisted_3,
                      _hoisted_4,
                      _hoisted_5,
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_n_h4, { style: {"margin-bottom":"0"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_n_text, { type: "primary" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.hound.name), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode(_component_n_space, { justify: "right" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_text, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.hound.sex), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 2)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_n_form_item, {
            label: "Hound",
            path: "houndId",
            style: {"margin-top":"1rem"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_select, {
                disabled: _ctx.loading,
                class: "big-select",
                options: _ctx.houndOptions,
                value: _ctx.formValue.houndId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValue.houndId) = $event)),
                style: {"width":"100%"},
                "render-label": _ctx.renderLabel,
                "render-tag": _ctx.renderTag
              }, null, 8, ["disabled", "options", "value", "render-label", "render-tag"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClose"])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}